import { Box } from '@chakra-ui/react';
import React from 'react';
import Streaks from '../../../components/V2/Streaks/Streaks';

const StreaksPage = () => {
	return (
		<Box h="full">
			<Streaks />
		</Box>
	);
};

export default StreaksPage;
